import { render, staticRenderFns } from "./home-card.vue?vue&type=template&id=207b0140&scoped=true&"
import script from "./home-card.vue?vue&type=script&lang=js&"
export * from "./home-card.vue?vue&type=script&lang=js&"
import style0 from "./home-card.vue?vue&type=style&index=0&id=207b0140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207b0140",
  null
  
)

export default component.exports